<template>
  <div>
    <el-button @click="$router.back()" style="margin-bottom:16px;">← 返回</el-button>
    <h2>预警详情</h2>

    <el-card v-if="detail" :style="{ borderLeft: detail.riskLevel === 'HIGH' ? '4px solid #F56C6C' : '4px solid #E6A23C' }">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="预警类型">{{ detail.warningTypeText }}</el-descriptions-item>
        <el-descriptions-item label="风险等级">
          <el-tag :type="detail.riskLevel === 'HIGH' ? 'danger' : 'warning'" size="small">
            {{ detail.riskLevelText }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="账户名称">{{ detail.accountName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备编号">{{ detail.deviceNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="试剂名称">{{ detail.reagentName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="采购数量">{{ detail.purchaseBottleCount }} 瓶</el-descriptions-item>
        <el-descriptions-item label="理论检测次数">{{ detail.theoryTestTimes }}</el-descriptions-item>
        <el-descriptions-item label="实际检测次数">{{ detail.actualTestTimes }}</el-descriptions-item>
        <el-descriptions-item label="使用率">{{ detail.usageRate != null ? detail.usageRate + '%' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="处理状态">
          <el-tag :type="detail.handleStatus === 'HANDLED' ? 'success' : 'info'" size="small">
            {{ detail.handleStatus === 'HANDLED' ? '已处理' : '未处理' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="触发原因" :span="2">{{ detail.warningContent }}</el-descriptions-item>
        <el-descriptions-item v-if="detail.handleRemark" label="处理备注" :span="2">{{ detail.handleRemark }}</el-descriptions-item>
        <el-descriptions-item v-if="detail.handleTime" label="处理时间">{{ detail.handleTime }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <div style="margin-top:20px; text-align:center;" v-if="detail && detail.handleStatus !== 'HANDLED'">
      <el-button type="primary" @click="showHandleDialog">标记已处理</el-button>
    </div>

    <el-dialog title="处理预警" v-model="handleDialogVisible" width="500px">
      <el-form label-width="80px">
        <el-form-item label="处理备注">
          <el-input v-model="handleRemark" type="textarea" :rows="3" placeholder="请输入处理备注" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="handleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitHandle">确认处理</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getWarningDetail, handleWarning } from "@/api/reagentMonitor";

export default {
  data() {
    return {
      detail: null,
      handleDialogVisible: false,
      handleRemark: "",
    };
  },
  created() {
    const warningId = this.$route.params.warningId;
    if (warningId) {
      this.loadDetail(warningId);
    }
  },
  methods: {
    async loadDetail(warningId) {
      try {
        const res = await getWarningDetail(warningId);
        if (res.code === 200) {
          this.detail = res.data;
        }
      } catch (e) { console.error(e); }
    },
    showHandleDialog() {
      this.handleRemark = "";
      this.handleDialogVisible = true;
    },
    async submitHandle() {
      try {
        const res = await handleWarning({
          warningId: this.detail.id,
          handleRemark: this.handleRemark,
        });
        if (res.code === 200) {
          this.$message.success("处理成功");
          this.handleDialogVisible = false;
          this.loadDetail(this.detail.id);
        }
      } catch (e) { console.error(e); }
    },
  },
};
</script>
